// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c8Sy","input":"styles_input__8Ayyd"};